import { IAPIAction } from "interfaces";
import { DeliveryStatusDashboard } from "constants/Actions";

const {
  GET_DELIVERY_STATUS_LIST,
  GET_DELIVERY_STATUS_LIST_SUCCESS,
  GET_DELIVERY_STATUS_LIST_FAIL,

  GET_DASHBOARD_STATUS_DETAILS,
  GET_DASHBOARD_STATUS_DETAILS_SUCCESS,
  GET_DASHBOARD_STATUS_DETAILS_FAIL,
} = DeliveryStatusDashboard;

export const deliveryStatusDashboard: Readonly<IAPIAction> = {
  deliveryStatus: {
    get: (data) => ({
      type: GET_DELIVERY_STATUS_LIST,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_DELIVERY_STATUS_LIST_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_DELIVERY_STATUS_LIST_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  deliveryStatusDetails: {
    get: (data) => ({
      type: GET_DASHBOARD_STATUS_DETAILS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_DASHBOARD_STATUS_DETAILS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_DASHBOARD_STATUS_DETAILS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
 
};
